import { filterNavItems, type NavItem } from '@/navigation/nav-items';
import type { OmniNavSection } from './types';

function toOmniItem(item: Pick<NavItem, 'id' | 'label' | 'path' | 'icon'>, hint?: string) {
  return {
    key: item.id,
    label: item.label,
    path: item.path,
    icon: item.icon,
    hint,
  };
}

/**
 * Build omni-search page sections from the live sidebar nav.
 * Nested nav children are listed individually with a parent hint.
 */
export function buildOmniNavSections(options: { items: NavItem[]; isAdmin: boolean }): OmniNavSection[] {
  const pages = filterNavItems(options.items, { isAdmin: options.isAdmin });

  const pageItems = pages.flatMap((item) => {
    if (!item.children?.length) {
      return [toOmniItem(item)];
    }
    // Children only (avoids a duplicate entry for a parent and its first child).
    // Hint lets omni-search match the parent's name via nav-match.
    return item.children.map((child) =>
      toOmniItem(
        {
          id: child.id,
          label: child.label,
          path: child.path,
          icon: item.icon,
        },
        item.label
      )
    );
  });

  const sections: OmniNavSection[] = [
    {
      key: 'pages',
      label: 'Pages',
      items: pageItems,
    },
  ];

  return sections;
}
